// extracted by mini-css-extract-plugin
export default {"hls":"HighLevelStats_hls__o+VeS","infoDiv":"HighLevelStats_infoDiv__8YUrz"};